export default {"src":"/_next/static/media/regendb-logo-long.acfbd5f9.svg","height":168,"width":720,"blurWidth":0,"blurHeight":0};